// Money movements — the history the console did not have.
//
// Operator, 4 Sept 2026: "These is no screen that shows Record in/out & Move
// in/out history + peerticular party trades/movement histroy — that should be
// there for verification, Must build appropriately."
//
// WHAT THIS IS. Every transaction that MOVED MONEY ON A DESK ACCOUNT, whatever
// the books call it: Record money, Move money, costs, adjustments, the owner's
// capital and drawings, the cheque postings that take money off an account —
// and the account legs of a TRADE.
//
// The trade legs are here because the screen exists to be tied to Treasury.
// Transaction 97 put 2,55,000 AED into Cash·Office and took 69,293.50 USDT off
// the hot wallet; it was typed `trade`, so this screen dropped it outright,
// and the desk's own cash box could not be reconciled against its own history.
// A trade's legs carry their own kind — `trade` — so the row reads honestly
// and so anyone who wants only Record and Move can drop them with one chip.
//
// WHAT IS STILL NOT HERE. /trades is the TRADES log: what was AGREED, at what
// rate, with whom. And a posting that touched no account moved no money —
// trade_margin, the cheque fee memos — so it stays out. A party's own history,
// trades and money alike, is on that party's statement.
//
// ONE EXCEPTION, kept deliberately: an opening balance that landed on a PARTY
// rather than an account. No money came in or out on 1 September — it is the
// desk writing down what someone already owed — but leaving it off meant this
// screen and the party's own statement said different things about the same
// party. It is here, filed as a restatement rather than as money, so it reads
// as what it is and contributes nothing to the totals.
//
// HOW THE TOTALS TIE. Over all history they equal the account's balance
// exactly, on every account and every asset, matching what Treasury itself
// reads. Ask for a DATE WINDOW and they need not: an entry made inside it and
// reversed after it is in neither, so the window reads light against the
// balance on the closing night. The screen says so when it happens rather
// than letting it be found.
//
// GET /api/movements reads the ledger from Postgres, so it can filter, page,
// and total the WHOLE filtered set rather than the page.
//
// Minimised 14 Sept 2026 (sweep §5.14 / item 54): one-clause subtitle, the
// period chips are the shared PeriodChips (same order and default as the
// Trades log), "Undone" is one chip that says "Show reversed", Amount and
// Asset are one cell, the totals cards wrap on the phone, the reference
// copies on a click, and the sentences that explained the screen live in
// "About this screen". 15 Sept: the sentence column is gone — it said the
// What, Amount, Party and Account cells over again — so a row is one line:
// When · Type · Party · Account · Amount · Reference. The words and the note
// ride on the row's tooltip.
//
// Desktop (lg+) follows the console contract in styles.css and the trades
// log's grain: the filters in one line at the top of the table card, a
// full-height scroller beneath. Below lg the same pieces stack, the filter
// line wrapping, each table scrolling sideways.
//
// CURRENCY-WISE BLOCKS (operator, 17 Sept 2026, on a wide monitor: "need
// better UI & Clear view, currency wise statements … same currency wise view
// on money/trades screens. still the screen looks mis-aligned … fonts too
// small, movement type is too short, description lines are not in sync and
// not in same formats, no colors properly used"). The one table is now ONE
// BLOCK PER CURRENCY, largest net first, each with its own header carrying
// the net, in and out over the whole filtered set — so the totals cards above
// the table are gone; the headers say the same numbers, beside the rows they
// describe. Every width, size and colour is components/Ledger's: the type
// pill owns a fixed column so every party starts on one vertical line, the
// figure column has a real width and sits near the words under the 1240px
// block cap, the day rows read Today / Yesterday / the weekday as the party
// statement's do, and the pill's colour comes from the shared word map.
//
// REVERSING AN ENTRY (operator, 17 Sept 2026: "How to void this entry? no
// option"). Every live money row — not a trade's leg, which opens the deal
// panel where Void lives — carries the shared door, components/ReverseEntry:
// a small button at the row's end, the panel beneath the row, the reason
// chips, the read-back, one red button. The row leaves the live list on the
// refresh that follows, so the success line sits above the table with
// "Book it again →" carrying the figures into Record money / Move money.
//
// A BANK STATEMENT PER CURRENCY (operator, 17 Sept 2026, holding a Wio bank
// statement: "fix the description lines format too … I need total also at
// each line … look how clean it looks"). Wio prints, per currency, an opening
// and a closing balance and then five columns — Date · Ref · Description ·
// Amount · Balance — the description short and counterpart-led ("From ALUX
// IT SOLUTIONS LLC", "To …", "AED to EUR"), never an amount inside it. So:
//
//   ROWS PER LEG. The route now sends `legs` — per asset the transaction
//   moved on the accounts in scope, its signed net and the balance those
//   accounts held right after it. A transaction stands in the block of EACH
//   asset it has a leg in: a trade is one row under AED (+100,000, Office
//   cash) and one under USDT (−27,188.60, the hot wallet), each with its own
//   balance. A railless row — between parties, a party opening, a profit
//   share — has no legs and stands once, in its head asset, with a dash for
//   the movement and no balance: it moved nothing on these accounts.
//   DESCRIPTION, built here from the row's structured fields, one shape per
//   kind, the counterpart first and never a figure: "From {party}" / "To
//   {party}" / "Into {account}" and "Out of {account}" for money with no
//   party / the party alone on a trade / "To {account}" on a move ("From
//   {account}" on the receiving side's own statement; "· network fee" when
//   the fee is all that is left of it) / the cost's words / "Owner put in" /
//   "Wrote off · {party}" / "Profit share · {party}" / "Opening balance".
//   ACCOUNT is one account per line — the leg's own. The BFF's full sentence
//   and the note stay on the row's tooltip.
//   MOVEMENT is the leg's own signed net (a fee-free move with both sides in
//   scope shows the amount that crossed, unsigned); BALANCE the leg's
//   running figure.
//   The block header carries the closing balance, with the opening and the in
//   and out beside it. With the account filter naming one account the block
//   is that account's statement — its title says so — and the Account column
//   is dropped, since every row would repeat the same words.
//
// AN OLDER WORKER STILL READS. Until the Worker is deployed the rows carry no
// `legs` and the totals no `opening` / `closing`: a row then stands once in
// its head asset with the movement it always showed and no Balance column,
// and the header shows the net, in and out as before.
//
// THE ROWS ARE SHARED (18 Sept 2026, operator on Home: "NEED RECENT MONEY
// MOVEMENTS HERE AS WELL"). The currency blocks, the day rows, the lines and
// the Description builder live in components/MovementTable, drawn here with
// every column and the reverse door on; Home draws the same table over its
// ten newest movements. This screen keeps what is its own: the filters, the
// reads, the paging, the empty state and the deal panel.
//
// THE FILTERS ARE A LINE, NOT A RAIL (18 Sept 2026, operator on the Trades
// screen: "how can we make this left side console look better?"). The 236px
// card on the left is gone; the filters sit in one wrapping line at the top
// of the table card (components/FilterBar) — Search · When · Type · Asset,
// the four the Trades log also has and in its order, then Party · Account,
// then Show reversed and Clear filters at the line's end — and the blocks
// take the full width beneath. The two long lists, Type and Asset,
// are one <select> each; the period keeps its chips. The line stands in every
// state of the read — a party the books do not have, a failed first read —
// so the filter that caused it can always be changed. Every door (?kind
// ?party ?rail ?asset ?from ?to ?q) reads as before.

import { useEffect, useMemo, useState } from 'react';
import { DeskSwitch, useDesk } from '../components/DeskSwitch';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { ApiError } from '../lib/errors';
import { Pending } from '../components/Pending';
import { EmptyState, StateLine } from '../components/kit';
import { LAST_READ_NONE, ReadFailed } from '../components/OnboardingParts';
import { Chip } from '../components/FilterRail';
import { FilterBar, FilterItem, FilterPair, FilterSelect } from '../components/FilterBar';
import { PeriodChips, periodDays, type PeriodValue } from '../components/PeriodChips';
import { Combobox, type ComboboxOption } from '../components/Combobox';
import { DealSlideOver } from '../components/DealSlideOver';
import { MovementTable, type MovementLineRow } from '../components/MovementTable';
import { ReversedLine, type ReversedOutcome } from '../components/ReverseEntry';
import {
  api,
  type MovementKindFilter,
  type MovementTotal, type TradeRow,
} from '../lib/api';
import { ScreenHeader } from '../components/ScreenHeader';
import { displayAsset, fmtAmount } from '../lib/format';
import {
  partyName, partySubtitle, railName, railKindGroupLabel,
  needsNameReview, isStale, compareRelevance, foldAsset, movementKindLabel,
} from '../lib/naming';
import { ASSETS } from '../lib/workflow';

// One page is a hundred movements. The books hold a few hundred in total
// today, so most reads are a single page; the cursor is what keeps that true
// as they grow, and it is a KEYSET — a movement posted while the operator is
// reading can neither duplicate a row nor hide one.
const PAGE = 100;
/** The trades log's own page, read here only to name the deal behind an
 *  account leg. Same number TradesLog asks for, so the two share one cache entry. */
const TRADE_PAGE = 200;

// ── the filter vocabulary ────────────────────────────────────────────────────

// The shared union (lib/api.ts MovementKind) carries every kind the route
// serves, `trade` included — the chips are that vocabulary plus "don't filter".
// `p2p` (11 Sept 2026): a balance moved from one party to another — no desk
// account, so it sits beside Move, the other kind that puts nothing in or out.
const KIND_FILTERS: MovementKindFilter[] =
  ['all', 'trade', 'money_in', 'money_out', 'rail_move', 'p2p', 'adjustment', 'expense', 'owner'];

/** The desk's asset vocabulary, FOLDED. The ledger stores bare USDT/USDC —
 *  the chain lives in the wallet's name — so one chip per fold group is one
 *  chip per thing the operator can actually filter on. The route folds
 *  whatever it is sent, so either dialect would work; this is the one that
 *  matches what the rows come back saying. */
const ASSET_FILTERS: string[] = [...new Set(ASSETS.map((a) => foldAsset(a)))];

/** The two name pickers' seat in the bar: w-48, and their box at the PHONE FIELD size below lg — 16px, under which iOS zooms
 *  the page when the field takes focus (it was 12px, the size the bare `.input` once did NOT stand at; 22 Oct 2026) — and at
 *  body from lg, as the console rule (styles.css) levels every `.input`. */
const COMBO = 'w-full lg:w-48 [&_input]:text-field lg:[&_input]:text-body';

/** Typing must not fire a read per keystroke — the search runs server-side,
 *  over reference and notes. */
function useDebounced<T>(value: T, ms = 350): T {
  const [held, setHeld] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setHeld(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return held;
}

// ── screen ───────────────────────────────────────────────────────────────────

export function Movements() {
  // Landed on from a party page ("see every movement"), from a desk account
  // on Treasury, or from a pasted link. Read ONCE, as the initial state — the
  // filters are then the operator's, and a re-render must not drag them back
  // to the URL's.
  const [params] = useSearchParams();
  // Which desk's movements (5 Sept: India's account moves were invisible here).
  const [entity, setEntity] = useDesk();
  const [kind, setKind]     = useState<MovementKindFilter>(() => {
    const k = params.get('kind') as MovementKindFilter | null;
    return k && KIND_FILTERS.includes(k) ? k : 'all';
  });
  // TYPED, then held. Both pickers are free-text boxes with a dropdown over
  // them — every keystroke is an onChange — and each keystroke used to be a
  // query key: a full ledger read, and for the party one a GET on the party
  // itself that 404s on every prefix of a real name. The search box beside
  // them has been debounced since it was written; these are the same box.
  const [partyTyped, setPartyTyped] = useState(() => params.get('party') ?? '');
  const [railTyped, setRailTyped]   = useState(() => params.get('rail') ?? '');
  // A link may carry either dialect (?asset=USDTTRC); the chips below are the
  // folded vocabulary the rows come back speaking, so fold it on the way in or
  // the chip that IS selected renders as though nothing were.
  const [asset, setAsset]   = useState(() => foldAsset(params.get('asset') ?? ''));
  // THE PERIOD. ?from / ?to name exact days. A history door — a party's
  // statement, an account's history icon on Treasury — asks for the whole
  // history and opens on All time; the bare screen opens on today, in the
  // same order and default as the Trades log (§5.14).
  const [period, setPeriod] = useState<PeriodValue>(() => {
    const from = params.get('from') ?? '', to = params.get('to') ?? '';
    if (from || to) return { key: 'custom', from, to };
    return params.get('party') || params.get('rail') || params.get('q') ? { key: 'all' } : { key: 'today' };
  });
  // ?q=<reference>: a statement row landing on its own entry.
  const [typed, setTyped]   = useState(() => params.get('q') ?? '');
  const [undone, setUndone] = useState(false);
  const search = useDebounced(typed.trim());
  // What the reads are actually pointed at. The boxes stay live; the queries
  // wait for the typing to stop.
  const party = useDebounced(partyTyped.trim());
  const rail  = useDebounced(railTyped.trim());

  const win = periodDays(period);

  // Names for the two pickers. Both are cheap, cached, and shared with the
  // screens that already read them — the party list sits under the same
  // ['parties'] root key the Parties screen and the palette use.
  const parties = useQuery({
    queryKey: ['parties', 'movement-filter', entity],
    queryFn:  () => api.listParties({ entity: entity, pageSize: 500 }),
    staleTime: 60_000,
  });
  const rails = useQuery({
    queryKey: ['treasury', 'slugs', entity],
    queryFn:  () => api.treasurySlugs(entity),
    staleTime: 60_000,
  });

  // A PARTY THE BOOKS DO NOT HAVE MUST NOT READ AS "NOTHING MOVED".
  // The route validates the account (an unknown one is refused in a sentence)
  // but not the party — a mistyped name simply matches no transaction, and an
  // empty ledger is the most expensive wrong answer this screen can give.
  //
  // ASKED OF THE PARTY ITSELF, not of the list above. GET /api/parties returns
  // `status = 'active'` only, and 46 of this desk's 177 parties are archived —
  // exactly the ones whose history somebody goes looking for. Checking the
  // filter against that list would have told the operator his archived
  // counterparty does not exist. GET /api/parties/:slug answers for every
  // party and 404s only for one that truly is not there. It shares the key
  // PartyDetail uses, so this is usually a cache hit and never a second read.
  const partyCheck = useQuery({
    queryKey: ['party', party, entity],
    queryFn:  () => api.partyDetail(party, entity),
    enabled:  !!party,
    retry:    false,   // a 404 is an answer, not a flake to retry through
  });
  // ONLY a 404 means "no such party". A dead tunnel must not be reported as a
  // missing counterparty — that one is an error, and it is shown as one.
  const partyUnknown =
    !!party && partyCheck.isError && (partyCheck.error as ApiError)?.status === 404;

  const q = useInfiniteQuery({
    queryKey: ['movements', 'log', entity, kind, party, rail, asset,
               win.from ?? '', win.to ?? '', search, undone],
    queryFn: ({ pageParam }) => api.movements({
      entity: entity,
      kind,
      party: party || undefined,
      rail:  rail  || undefined,
      asset: asset || undefined,
      from: win.from,
      to:   win.to,
      q: search || undefined,
      limit: PAGE,
      cursor: pageParam || undefined,
      include_undone: undone,
    }),
    initialPageParam: '',
    getNextPageParam: (last) => last.next_cursor ?? undefined,
    enabled: !partyUnknown,
    // A movement posted on another screen or another tab has to show here
    // without a navigation — the same rule the settle screen follows.
    refetchOnWindowFocus: true,
  });

  const rows: MovementLineRow[] = useMemo(
    () => q.data?.pages.flatMap((p) => p.rows) ?? [],
    [q.data],
  );

  // ── THE DEAL BEHIND AN ACCOUNT LEG ────────────────────────────────────────
  // A row was a dead end: the trades log opens a deal panel on a click and
  // this screen, which now carries a trade's legs, offered nothing. There is
  // no by-id read for a deal, so this is the trades log's own page, asked for
  // under the SAME key TradesLog uses — opening a deal from here is a cache
  // hit, and neither screen fetches it twice. Nothing is read at all until a
  // row on screen actually names a deal.
  const [dealId, setDealId] = useState<string | null>(null);
  // The last entry reversed from a row — the row itself has left the live
  // list by the time the operator reads this (see the header).
  const [reversed, setReversed] = useState<ReversedOutcome | null>(null);
  const trades = useQuery({
    queryKey: ['trades', 'log', entity, TRADE_PAGE],
    queryFn:  () => api.listTrades(entity, TRADE_PAGE),
    enabled:  rows.some((m) => !!m.deal_id),
    staleTime: 60_000,
  });
  const dealsById = useMemo(
    () => new Map<string, TradeRow>((trades.data?.trades ?? []).map((t) => [t.deal_id, t])),
    [trades.data],
  );
  // The totals describe the WHOLE filtered set and are identical on every
  // page, so the first page is as good as the last — and a page 2 that has not
  // been asked for cannot change them.
  const totals: MovementTotal[] = q.data?.pages[0]?.totals ?? [];
  // A window whose totals cannot be checked against a balance — see the route.
  const caveat = q.data?.pages[0]?.window_caveat ?? null;

  // ONE BLOCK PER CURRENCY (17 Sept 2026): components/MovementTable builds
  // the blocks from the rows and the totals — largest net first, a
  // transaction in the block of every asset it has a leg in — and draws them.
  // THE STATEMENT COLUMNS ARE THERE ONLY WHEN THE WORKER SENDS THEM. An older
  // Worker's rows carry no `legs` at all, and a Balance column of blanks
  // would read as "no balance" — so the column stands only once a row has
  // brought the field.
  const statement = rows.some((m) => Array.isArray(m.legs));
  // With the account filter naming ONE account, every block is that
  // account's own statement: the title names it, and the Account column —
  // which would repeat the same words on every row — is dropped. Named the
  // way the rows name it: the operator-set label a row carries for that
  // slug wins (lib/naming — the label is the name), and the slug alone is
  // only the fallback before a row has landed.
  const oneAccount = useMemo(() => {
    if (!rail) return null;
    for (const m of rows) {
      for (const r of [m.rail, m.counter_rail, m.other_rail]) {
        if (r && r.slug === rail) return railName({ slug: r.slug, label: r.label });
      }
    }
    return railName({ slug: rail });
  }, [rail, rows]);

  // WHICH FAILURE THIS IS DECIDES WHAT MAY STAY ON SCREEN.
  //
  // In TanStack v5 a failed "Load more" — or a failed refetch when the tab is
  // focused, which this screen asks for — puts the WHOLE query into the error
  // state. The screen answered that by replacing itself: a hundred rows the
  // operator was reading vanished behind "nothing was read", which was not
  // true of them. `q.data` is the honest test: it is undefined only while no
  // page has ever landed, and that is the only case where nothing was read.
  //
  // A NEXT PAGE THAT FAILED MUST STILL SAY SO — silence there leaves a
  // half-read list looking finished.
  const nothingRead  = q.isError && !q.data;
  const pagingError  = q.isFetchNextPageError ? q.error : null;
  const refreshError = q.isError && !!q.data && !q.isFetchNextPageError ? q.error : null;
  // The party filter has not been resolved yet — see the body below.
  const waitingOnParty = !!party && partyCheck.isPending;
  // Rows are on screen (or an honest empty list is): the count line, the
  // warnings about the read and the table itself stand only then. PENDING, not "loading": a first read opened with no
  // connection is paused — no answer, nothing fetching — and it is waiting, never an empty list (Astra, 22 Oct 2026).
  const loaded = !partyUnknown && !waitingOnParty && !nothingRead && !q.isPending;

  const partyOptions: ComboboxOption[] = useMemo(() => {
    const list = parties.data?.parties ?? [];
    return [...list]
      .filter((p) => p.party_type !== 'own_account')
      .sort(compareRelevance)
      .map((p) => ({
        value:     p.slug,
        label:     partyName(p),
        secondary: partySubtitle(p, { compact: true }),
        stale:     isStale(p),
        review:    needsNameReview(p.display_name),
      }));
  }, [parties.data]);

  const railOptions: ComboboxOption[] = useMemo(() => {
    const out: ComboboxOption[] = [];
    for (const g of rails.data?.groups ?? []) {
      for (const s of g.slugs) {
        out.push({ value: s, label: railName({ slug: s }), group: railKindGroupLabel(g.kind) });
      }
    }
    return out;
  }, [rails.data]);

  const assetOptions = useMemo(() => {
    const list = asset && !ASSET_FILTERS.includes(asset) ? [...ASSET_FILTERS, asset] : ASSET_FILTERS;
    return list.map((a) => ({ value: a, label: displayAsset(a) }));
  }, [asset]);

  const filtered = !!(party || rail || asset || search || undone || kind !== 'all' || period.key !== 'today');
  const clearAll = () => {
    setKind('all'); setPartyTyped(''); setRailTyped(''); setAsset('');
    setPeriod({ key: 'today' }); setTyped(''); setUndone(false);
  };

  return (
    <div className="space-y-3 lg:space-y-0 lg:flex lg:flex-col lg:gap-3 lg:h-[calc(100dvh-7.5rem)]">
      <ScreenHeader
        className="lg:shrink-0"
        title="Money movements"
        actions={<DeskSwitch value={entity} onChange={setEntity} />}
        help={
          <>
            <p>
              Everything the desk recorded in or out, moved between accounts, wrote off, spent, or the
              owner put in and took out — and what a trade moved on an account. What a trade was agreed
              at is on the Trades log.
            </p>
            <p>
              One block per currency, largest net first, read like a bank statement: Description names the
              other side of the entry, Movement is what this entry moved, and Balance is the account&rsquo;s
              balance right after it, over the accounts the filters name — one account when the account
              filter is set, else every desk account — whatever the type, party and search filters say.
              Each block&rsquo;s header carries the closing balance, with the opening and the money in
              and out over every entry that matches the filters, not just the rows on screen; inside a date
              window an entry reversed after the window is in neither in nor out, and the screen says so.
            </p>
            <p>
              Show reversed adds the entries that were reversed and the reversals that undid them, both
              labelled. Search reads the reference, the note and a chain id. Hover a row for its words
              and its note; a deal id opens the deal, a reference copies on a click.
            </p>
          </>
        }
      />

      <div className="min-w-0 space-y-3 lg:flex lg:flex-col lg:flex-1 lg:gap-3 lg:space-y-0 lg:min-h-0">
        {/* A FAILED REFRESH IS A DIFFERENT SENTENCE. What is on screen
            was read and is real; it is only not the newest. */}
        {loaded && refreshError && (
          <ReadFailed what="the movements" error={refreshError} says={rows.length === 0 ? LAST_READ_NONE : 'showing the last good read'} retry={() => { void q.refetch(); }} className="mt-1 lg:shrink-0" />
        )}
        {loaded && (
          <ReversedLine outcome={reversed} onDismiss={() => setReversed(null)} className="lg:shrink-0" />
        )}
        {/* A WARNING THAT GUARDS MONEY stays — as ONE line, with the figures behind a tap (design system, 22 Oct 2026):
            the totals are short, and by how much is one tap away. */}
        {loaded && caveat && (
          <StateLine
            tone="warn"
            className="mt-1 lg:shrink-0"
            more={
              <>
                {caveat.rows === 1 ? 'One entry here was' : `${caveat.rows} entries here were`}
                {' '}reversed after this window — totals are short by{' '}
                {caveat.per_asset.map((a) => `${fmtAmount(a.amount, a.asset)}\u00A0${displayAsset(a.asset)}`).join(', ')}.
                {' '}Drop the dates to tie exactly.
              </>
            }
          >
            Totals are short — entries reversed after this window.
          </StateLine>
        )}

        {/* ── The table card: the filter line, the count line, the blocks ──
            `lg:overflow-hidden`, not on the phone: the two pickers open a
            dropdown INSIDE this card, and below lg the card is only as tall
            as its rows — a short list would clip the list of names. On the
            desktop the card is full-height, as the old rail was. */}
        <div className="card p-0 lg:overflow-hidden flex-1 min-w-0 lg:flex lg:flex-col lg:min-h-0">
          <FilterBar
            moreOpen={kind !== 'all' || asset !== '' || !!party || !!railTyped || undone}
            more={
              <>
            {/* Eight kinds: a long list, so one <select>. 'all' stays the
                value that means "don't filter" — the query does not change. */}
            {/* Type and Asset each take a line on the phone — "Between
                parties" does not fit half of one at the phone's 16px. */}
            <FilterItem label="Type">
              <FilterSelect
                value={kind}
                onChange={setKind}
                allValue="all"
                options={KIND_FILTERS.filter((k) => k !== 'all').map((k) => ({ value: k, label: movementKindLabel(k) }))}
              />
            </FilterItem>

            <FilterItem label="Asset">
              {/* A pasted ?asset= outside the desk's vocabulary still filters
                  the read, as it always has — so it stands as its own option,
                  and the select never says "All" while an asset is set. */}
              <FilterSelect
                value={asset}
                onChange={setAsset}
                allValue=""
                options={assetOptions}
              />
            </FilterItem>

            <FilterPair>
            <FilterItem label="Party">
              <div className={COMBO}>
                <Combobox
                  value={partyTyped}
                  onChange={setPartyTyped}
                  options={partyOptions}
                  loading={parties.isPending}
                  placeholder="any party"
                  emptyHint="No active party by that name — type an archived one in full."
                  // THE LIST COULD NOT BE READ: a line with its own Try again, under the closed box and FIRST in the open list — over rows kept from an
                  // earlier read it says they are the last read (the empty hint above is drawn only when there is no row at all).
                  readFailed={parties.isError ? <ReadFailed what="the parties" error={parties.error} says={parties.data ? 'showing the last read' : undefined} retry={() => { void parties.refetch(); }} /> : undefined}
                />
              </div>
              {/* The picker holds the party's id, because that is what the
                  route wants. This says who that is, so a filter cannot
                  silently be pointed at the wrong counterparty. */}
              {party && partyCheck.data && (
                <span className="max-w-[12rem] break-words text-meta text-tg-hint lg:max-w-[20rem] lg:line-clamp-1">
                  {partyName(partyCheck.data.party)}
                  {partyCheck.data.party.status !== 'active' && ' · archived'}
                </span>
              )}
            </FilterItem>

            <FilterItem label="Account">
              <div className={COMBO}>
                <Combobox
                  value={railTyped}
                  onChange={setRailTyped}
                  options={railOptions}
                  loading={rails.isPending}
                  placeholder="any account"
                  emptyHint="No account by that name."
                  readFailed={rails.isError ? <ReadFailed what="the accounts" error={rails.error} says={rails.data ? 'showing the last read' : undefined} retry={() => { void rails.refetch(); }} /> : undefined}
                />
              </div>
            </FilterItem>
            </FilterPair>
              </>
            }
            toolbar={loaded ? (
              <>
                {/* No "0 entries" over "Nothing in this period." — said once. */}
                {rows.length > 0 && (
                  <p className="text-meta text-tg-hint">
                    <span className="font-mono tabular text-tg-text font-medium">{rows.length}</span>
                    {' '}{rows.length === 1 ? 'entry' : 'entries'}
                    {q.hasNextPage && ' · more below'}
                  </p>
                )}
                {q.isFetching && !q.isFetchingNextPage && (
                  <span className="text-meta text-tg-hint">Reading…</span>
                )}
              </>
            ) : undefined}
            trailing={
              <>
                {/* One chip, no label (§6 "Show reversed") — the same words on
                    the Statement. What it shows is said in About this screen. */}
                <Chip active={undone} onClick={() => setUndone((v) => !v)}>Show reversed</Chip>
                {filtered && (
                  <button type="button" onClick={clearAll} className="btn-link text-meta">Clear filters</button>
                )}
              </>
            }
          >
            <FilterItem label="Search">
              {/* Names what the haystack HOLDS. The route searches the reference
                  and the operator's own note — 33 of 56 real notes are a chain
                  id — not party names, which have their own picker beside it. */}
              <input
                className="input w-full lg:w-56 lg:text-meta"
                placeholder="Reference, note or chain id…"
                value={typed}
                onChange={(e) => setTyped(e.target.value)}
              />
            </FilterItem>

            {/* Search · When · Type · Asset — the same four in the same
                order as the Trades log; what is this screen's own comes after. */}
            <FilterItem label="When">
              <PeriodChips value={period} onChange={setPeriod} allTime />
            </FilterItem>

          </FilterBar>

          {partyUnknown ? (
            // Not an error and not an empty ledger — a filter that names
            // nobody. Said plainly, so it is never read as "nothing moved".
            <StateLine
              tone="warn"
              className="p-4"
              action={<button type="button" className="btn-link" onClick={() => setPartyTyped('')}>Drop the party filter</button>}
            >
              No party called <span className="font-mono break-words">{party}</span>.
            </StateLine>
          ) : waitingOnParty ? (
            // The party filter has not been resolved yet. Without this the
            // movement read (which runs in parallel) can land first and print
            // "nothing here" for a name that turns out a moment later not to
            // name anybody — a wrong answer, shown first.
            <div className="p-4"><Pending /></div>
          ) : nothingRead ? (
            // A FAILED FIRST READ IS NOT AN EMPTY LEDGER. No totals, no table,
            // no zeroes — the API's own sentence and nothing that could be
            // mistaken for an all-clear.
            <ReadFailed what="the movements" error={q.error} retry={() => { void q.refetch(); }} className="p-4" />
          ) : q.isPending ? (
            <div className="p-4"><Pending /></div>
          ) : (
            <div className="overflow-x-auto lg:overflow-y-auto lg:flex-1 lg:min-h-0">
              <MovementTable
                rows={rows}
                totals={totals}
                entity={entity}
                showAccount={!oneAccount}
                showBalance={statement}
                showReverse
                accountName={oneAccount}
                dealsById={dealsById}
                onOpenDeal={setDealId}
                onReversed={setReversed}
                dayRows={period.key !== 'today'}
              />

              {/* AN EMPTY CLAIM NEEDS A SUCCESSFUL READ: not one that failed (the line above says what the LAST read showed) and
                  not one that has not come (it waits, above). */}
              {rows.length === 0 && q.isSuccess && (
                <EmptyState
                  className="px-3 lg:py-16"
                  action={filtered ? <button type="button" onClick={clearAll} className="btn-link">Clear filters</button> : undefined}
                >
                  {period.key === 'all' ? 'Nothing here.' : 'Nothing in this period.'}
                </EmptyState>
              )}

              {q.hasNextPage && (
                <div className="px-3 py-3 text-center border-t border-stroke-soft">
                  <button
                    type="button"
                    className="btn-secondary text-meta py-1 px-3"
                    disabled={q.isFetchingNextPage}
                    onClick={() => q.fetchNextPage()}
                  >
                    {q.isFetchingNextPage ? 'Reading…' : 'Load more'}
                  </button>
                </div>
              )}
              {pagingError && (
                <ReadFailed what="more rows" error={pagingError} says="nothing after this row was read" retry={() => { void q.fetchNextPage(); }} className="border-t border-stroke-soft px-3 py-2" />
              )}
            </div>
          )}
        </div>
      </div>

      {/* The trades log's own panel, over the movement that settled the deal. */}
      <DealSlideOver
        deal={(dealId && dealsById.get(dealId)) || null}
        onClose={() => setDealId(null)}
      />
    </div>
  );
}
